module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "404.f6ff16c8.jpeg";